import { API_URL } from './src/auth/_requests';
if (API_URL === 'https://staging-api.tenantpay.com/api/v2') {
  const meta = document.createElement('meta');
  meta.name = 'robots';
  meta.content = 'noindex, nofollow';
  document.getElementsByTagName('head')[0].appendChild(meta);
}
